module.exports = __webpack_public_path__ + "img/11.90a9b912.jpg";